<template>
  <div>
    <breadcrumbs :two="{ path: '/tuning', name: this.parent_section_name }" three="Тюнинг/Экстерьер"></breadcrumbs>
    <div class="main">
      <h3>{{ page_title }}</h3>
      <div class="main-content">
        <loading v-if="loading"></loading>
        <div v-if="!loading">
          <el-form :model="addform" ref="addform" class="demo-ruleForm" label-position="top" label-width="100px"
                   :rules="addformRules">
            <el-steps :active="activeStepCarUpload" finish-status="success">
              <el-step title="Выберите файл PNG"></el-step>
              <el-step title='Нажмите "Загрузить"'></el-step>
              <el-step title="PNG загружены!"></el-step>
            </el-steps>
            <el-row :gutter="24">
              <el-col :span="12" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="PNG картинка" prop="images">
                  <input type="file" id="images" ref="images" v-on:change="handleFileUpload2()" required/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item v-if="addform.images">
              <el-button type="primary" @click="submitAddForm()">Загрузить</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs";
import {axios} from "@/api";
import Loading from "@/components/Loading";
import router from '@/router';

export default {
  name: 'CarsUpload',
  data() {
    return {
      loading: false,
      controller: 'user/tuning',
      page_title: 'Загрузка PNG',
      parent_section_name: 'Тюнинг/Экстерьер',
      tuning_id: this.$route.params.id,
      activeIndex: '/tuning/upload/:id',
      activeStepCarUpload: 0,
      addform: {
        'images': '',
      },
      addformRules: {
        images: [
          {required: true, message: 'Выберите файл', trigger: 'change'},
        ],
      },
    };
  },
  components: {
    Breadcrumbs,
    Loading
  },
  methods: {
    handleFileUpload2() {
      this.addform.images = this.$refs.images.files[0]
      this.nextStepAvatarUpload()
    },
    nextStepAvatarUpload() {
      if (this.activeStepCarUpload++ > 2) {
        this.activeStepCarUpload = 1;
      }
    },
    submitAddForm() {
      this.$refs['addform'].validate((valid) => {
        if (valid) {
          this.nextStepAvatarUpload()
          this.saveItem()
        } else {
          return false;
        }
      });
    },
    async saveItem() {
      try {
        this.$notify.info({
          title: 'Загрузка...',
        })
        const formData = new FormData()
        formData.append("file", this.addform.images)
        await axios.post(`${process.env.VUE_APP_API_V1}/${this.controller}/${this.$route.params.id}/upload`,
            formData,
            {
              headers: {
                "Accept": "application/json",
                "Content-Type": "multipart/form-data",
              }
            })
        this.$notify.success({
          title: 'Картинка успешно загружена!',
        })
        this.nextStepAvatarUpload()
        this.addform.images = '';
        router.push({ name: 'Tuning', params: { id: this.$route.params.id } })
      } catch (e) {
        if (e.response && e.response.status === 403) {
          this.loading = true;
          this.$notify.error({
            title: '403 - Доступ запрещён!',
            message: 'У Вас нет прав для совершения операции'
          });
        }
      }
    },
  },
  async mounted() {
  },
  watch: {},
}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-carousel__item .el-image {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
</style>
